import { injectable } from 'tsyringe';
import { authenticatedFetch } from '@/shared/auth/AuthenticatedFetch';

export interface OperatorInvoice {
    id: string;
    tenantId: string;
    tenantName: string;
    number: string;
    status: string;
    totalMinor: number;
    currency: string;
    planName: string | null;
    issuedAt: string | null;
    paidAt: string | null;
}

/** Cross-tenant invoices for the operator console (via the BFF). */
@injectable()
export class OperatorBillingService {
    async getInvoices(): Promise<OperatorInvoice[]> {
        const res = await authenticatedFetch('/_billing/api/operator/billing/invoices');
        if (!res.ok) throw new Error(`Failed to load invoices (${res.status})`);
        return (await res.json()) as OperatorInvoice[];
    }

    async openInvoicePdf(tenantId: string, invoiceId: string): Promise<void> {
        const res = await authenticatedFetch(`/_billing/api/operator/billing/tenants/${tenantId}/invoices/${invoiceId}/pdf`);
        if (!res.ok) throw new Error(`Failed to open invoice (${res.status})`);
        const { url } = (await res.json()) as { url: string };
        window.open(url, '_blank', 'noopener,noreferrer');
    }
}
